import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-sub-header-line',
	templateUrl: './sub-header-line.component.html',
	styleUrl: './sub-header-line.component.scss',
})
export class SubHeaderLineComponent {
	@Input() backgroundColor: string = '';
}
